import { Component, computed, inject, input } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { Theme } from '@core/enums/theme';
import { ThemeService } from '@core/services/theme.service';
import { SidebarService } from '@core/components/sidebar/service/sidebar.service';

@Component({
  selector: 'app-sidebar-logo',
  imports: [RouterLink, RouterLinkActive],
  template: `
    <a
      routerLinkActive
      routerLink="/home"
      class="w-full min-w-min cursor-pointer pt-1 pb-3"
      (isActiveChange)="updateActiveRoute($event)">
      <div class="group flex w-full items-center pt-1 pl-[5px]">
        @if (collapsed()) {
          <img class="size-8 shrink-0" [alt]="alt" [src]="collapsedImage" />
        } @else {
          <img
            class="h-8 w-[198px] shrink-0"
            [alt]="alt"
            [src]="expandedImage()" />
        }
      </div>
    </a>
  `,
})
export class SidebarLogoComponent {
  /** INJECTIONS **/
  /****/
  private readonly themeService = inject(ThemeService);

  /****/
  private readonly sidebarService = inject(SidebarService);

  /** INPUTS **/
  /****/
  readonly collapsed = input.required<boolean>();

  /** PROPERTIES **/
  /** Alt text for logo images **/
  protected readonly alt = 'Flowzilla';

  /** Logo image when sidebar is collapsed **/
  protected readonly collapsedImage = './assets/images/gorilla.svg';

  /** Logo image when sidebar is expanded, dynamically selected based on theme **/
  protected readonly expandedImage = computed(() => {
    const isDark = this.themeService.theme() === Theme.DARK;
    if (isDark) return './assets/images/flowzilla-dark.svg';
    else return './assets/images/flowzilla.svg';
  });

  protected updateActiveRoute(active: boolean) {
    this.sidebarService.setActiveRoute('home', active);
  }
}
